import React, {useEffect, useRef, useState} from "react";
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import './App.css'
import Header from "./Components/Header/Header";
import Hero from "./Components/Pages/ServicesList/Hero/Hero";
import Home from "./Components/Pages/ServicesList/Home";
import PlayerSupport from "./Components/Pages/PlayerSupport/PlayerSupport";
import FileComplaint from "./Components/Pages/Services/FileComplaint/FileComplaint";
import LicenseSupportServices from "./Components/Pages/Services/LicenseSupportServices/LicenseSupportServices";
import LicenseRegister from "./Components/Pages/Services/LicenseRegister/LicenseRegister";
import Contact from "./Components/Pages/Contact/Contact";
import Footer from "./Components/Footer/Footer";
import About from "./Components/Pages/About/About";
import DisputeTermsAndConditions from "./Components/Pages/DisputeTermsAndConditions/DisputeTermsAndConditions";
import ScrollToTop from "./Utils/ScrollToTop";

function App() {

    return (
        <Router>
            <Header />
            <ScrollToTop/>
            <Routes>
                <Route path='/' element={
                    <>
                        <Hero/>
                        <Home/>
                    </>
                }/>
                <Route path='/about-us' element={<About />}/>
                
                {/* services */}
                <Route path='/player-support' element={<PlayerSupport />}/>
                <Route path='/file-complaint' element={<FileComplaint/>}/>
                <Route path='/license-support-services' element={<LicenseSupportServices />}/>
                <Route path='/license-register' element={<LicenseRegister />}/>
                
                <Route path='/dispute-terms-conditions' element={<DisputeTermsAndConditions />}/>
                <Route path='/contact-us' element={<Contact/>}/>
            </Routes>
           <Footer/>
        </Router>
    );
}

export default App;